<template>
    <div>
        <a v-if="sortable.first" class="sort-button" @click="onFirst" >
            <div
                class="v-flex"
                style="justify-content: center"
                :class="sortFirst ? 'sort-selected' : ''"
            >
                <div>
                    {{ $t(group + '.' + first) }}
                </div>
                <div v-if="sortFirst" style="float: right">
                    <v-icon class="icon-sort">{{ sortFirst }}</v-icon>
                </div>
            </div>
        </a>

        <div v-if="!sortable.first">
            {{ $t(group + '.' + first) }}
        </div>

        <a v-if="second && sortable.second" class="sort-button" @click="onSecond">
            <div
                class="v-flex"
                style="justify-content: center"
                :class="sortSecond ? 'sort-selected' : ''"
            >
                <div>
                    {{ $t(group + '.' + second) }}
                </div>
                <div v-if="sortSecond" style="float: right">
                    <v-icon class="icon-sort" color="white">{{ sortSecond }}</v-icon>
                </div>
            </div>
        </a>

        <div v-if="second && !sortable.second" >
            {{ $t(group + '.' + second) }}
        </div>
    </div>
</template>

<script>
export default {
    name: "VTableHeaderCell",

    data: () => ({
        sortFirst  : null,
        sortSecond : null,
    }),

    props: {
        group: {
            required: true,
            type: String
        },
        value: {
            required: true,
            type: Object
        },
        first: {
            required: true,
            type: String
        },
        second: {
            required: false,
            type: String,
            default: function () {
                return null;
            }
        },
        sortable: {
            required: false,
            type: Object,
            default: function () {
                return {
                    first : true,
                    second: true
                }
            }
        }
    },

    mounted() {
        if (this.value.column === this.first) {
            if (this.value.dir === 'ASC') {
                this.sortFirst = "mdi-arrow-up-bold";
            } else {
                this.sortFirst = "mdi-arrow-down-bold";
            }

            return;
        }

        if (this.value.column === this.second) {
            if (this.value.dir === 'ASC') {
                this.sortSecond = "mdi-arrow-up-bold";
            } else {
                this.sortSecond = "mdi-arrow-down-bold";
            }
        }
    },

    watch: {
        value: {
            handler: function () {
                if (this.value.column !== this.first) {
                    this.sortFirst = null;
                }

                if (this.value.column !== this.second) {
                    this.sortSecond = null;
                }
            },
            deep: true
        }
    },

    methods: {
        onFirst () {
            if (this.value.column === this.first) {
                if (this.value.dir === 'ASC') {
                    this.sortFirst = "mdi-arrow-down-bold";
                    this.$emit("input", {
                        column: this.first,
                        dir   : "DESC"
                    });
                    return;
                }

                this.sortFirst = "mdi-arrow-up-bold";
                this.$emit("input", {
                    column: this.first,
                    dir   : "ASC"
                })

                return;
            }

            this.sortFirst = "mdi-arrow-up-bold";
            this.$emit("input", {
                column: this.first,
                dir   : "ASC"
            });
        },

        onSecond () {
            if (this.value.column === this.second) {
                if (this.value.dir === 'ASC') {
                    this.sortSecond = "mdi-arrow-down-bold";
                    this.$emit("input", {
                        column: this.second,
                        dir   : "DESC"
                    });
                    return;
                }

                this.sortSecond = "mdi-arrow-up-bold";
                this.$emit("input", {
                    column: this.second,
                    dir   : "ASC"
                })

                return;
            }

            this.sortSecond = "mdi-arrow-up-bold";
            this.$emit("input", {
                column: this.second,
                dir   : "ASC"
            });
        },
    }
}
</script>

<style scoped>

.icon-sort {
    font-size: 15px!important;
    height: 20px;
    width: 20px;
    margin-top: -2px;
}

.sort-button {
    color: white;
}


</style>

<style lang="scss" scoped>

.sort-selected {
    background-color: white!important;
    color: var(--v-primary-base)!important;
    border-radius: 4px;
}

.sort-selected i {
    color: var(--v-primary-base)!important;
}

</style>